/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Kiotviet_Unlinked_Filter_PendingInputs */

const vi_order_kiotviet_unlinked_filter_pending = /** @type {(inputs: Order_Kiotviet_Unlinked_Filter_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn KiotViet chưa nối sản phẩm`)
};

/**

* @param {Order_Kiotviet_Unlinked_Filter_PendingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_kiotviet_unlinked_filter_pending = /** @type {((inputs?: Order_Kiotviet_Unlinked_Filter_PendingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Kiotviet_Unlinked_Filter_PendingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_kiotviet_unlinked_filter_pending(inputs)
});